module.exports = __webpack_public_path__ + "img/avatar6.dc172119.png";